import React, { useEffect, useState } from "react";
import { withTranslation } from "react-i18next";
import { connect } from "react-redux";
import TldrChakraSlider from "../../../common/TldrChakraSlider";

const TLDRLineHeight = (props) => {
  const { canvasRef, activeElement, t } = props;

  const editorFormat = canvasRef?.handler.textHandler.getStyle(
    activeElement.format
  );

  const [lineHeight, setLineHeight] = useState(
    editorFormat?.lineHeight || 1.16
  );

  useEffect(() => {
    setLineHeight(activeElement.format?.lineHeight || 0.1);
  }, [activeElement.format]);

  function onLineHeightChange(selectedOption) {
    props.canvasRef.handler.textHandler.textLineHeight(
      selectedOption || 0.1,
      "push"
    );
  }

  function onLineHeightUpdate(selectedOption) {
    props.canvasRef.handler.textHandler.textLineHeight(
      selectedOption || 0.1,
      "commit"
    );
  }

  return (
    <TldrChakraSlider
      hideIndicator={true}
      onChange={onLineHeightChange}
      onUpdate={onLineHeightUpdate}
      step={0.1}
      domain={[0.1, 5]}
      values={lineHeight}
      title={t("fonts.line_height")}
      maxLength={4}
      handleFocus={onLineHeightChange}
      handleFocusOut={onLineHeightChange}
      showInputbox={true}
      showDecimals={true}
      variant="solid"
      isWithMarginLeft={true}
    />
  );
};

const mapStateToProps = (state) => ({
  activeElement: state.editor.activeElement,
});


export default withTranslation(["studio"])(
  connect(mapStateToProps)(TLDRLineHeight)
);
